// Darstellung der Suche: Icon und Farbe je Befehl bzw. Trefferart (nur Farben aus Handoff Pille §4).

import {
  AddressBook, Buildings, CalendarBlank, Door, EnvelopeSimple, FileText, Files, Gauge, MagnifyingGlass, PlusCircle,
  Receipt, ShieldCheck, SignOut, SquaresFour, Ticket, User, UserCircle, UserPlus, Users, Wrench, type Icon,
} from '@phosphor-icons/react';
import { FARBE } from '../pille-stil';

export interface Darstellung { icon: Icon; farbe: string }

export const BEFEHL_DARSTELLUNG: Record<string, Darstellung> = {
  'nav-dashboard': { icon: SquaresFour, farbe: FARBE.grau },
  'nav-objekte': { icon: Buildings, farbe: FARBE.gruen },
  'nav-eigentuemer': { icon: UserCircle, farbe: FARBE.orange },
  'nav-kontakte': { icon: AddressBook, farbe: FARBE.grau },
  'nav-dokumente': { icon: Files, farbe: FARBE.indigo },
  'nav-zaehler': { icon: Gauge, farbe: FARBE.orange },
  'nav-emails': { icon: EnvelopeSimple, farbe: FARBE.blau },
  'nav-mieter': { icon: Users, farbe: FARBE.blau },
  'nav-vertraege': { icon: FileText, farbe: FARBE.orange },
  'nav-tickets': { icon: Ticket, farbe: FARBE.violett },
  'nav-kalender': { icon: CalendarBlank, farbe: FARBE.rot },
  'nav-rechnungen': { icon: Receipt, farbe: FARBE.gruen },
  'nav-team': { icon: ShieldCheck, farbe: FARBE.indigo },
  'act-neuer-mieter': { icon: UserPlus, farbe: FARBE.gold },
  'act-neuer-eigentuemer': { icon: UserPlus, farbe: FARBE.gold },
  'act-neuer-kontakt': { icon: UserPlus, farbe: FARBE.gold },
  'act-neues-ticket': { icon: PlusCircle, farbe: FARBE.gold },
  'act-neue-rechnung': { icon: PlusCircle, farbe: FARBE.gold },
  'act-abmelden': { icon: SignOut, farbe: FARBE.rot },
};

export const TREFFER_DARSTELLUNG: Record<string, Darstellung> = {
  objekt: { icon: Buildings, farbe: FARBE.gruen },
  einheit: { icon: Door, farbe: FARBE.gruen },
  ticket: { icon: Ticket, farbe: FARBE.violett },
  rechnung: { icon: Receipt, farbe: FARBE.gruen },
  vertrag: { icon: FileText, farbe: FARBE.orange },
  termin: { icon: CalendarBlank, farbe: FARBE.rot },
  zaehler: { icon: Gauge, farbe: FARBE.orange },
  email: { icon: EnvelopeSimple, farbe: FARBE.blau },
  dokument: { icon: Files, farbe: FARBE.indigo },
  // Kontakte (Quelle aus kontakte_unified) – Farben wie „Neuer Kontakt“ im Prototyp
  mieter: { icon: User, farbe: FARBE.indigo },
  eigentuemer: { icon: UserCircle, farbe: FARBE.gold },
  dienstleister: { icon: Wrench, farbe: FARBE.orange },
  kontakt: { icon: User, farbe: FARBE.grau },
  contact: { icon: User, farbe: FARBE.grau },
};

export const STANDARD_DARSTELLUNG: Darstellung = { icon: MagnifyingGlass, farbe: FARBE.grau };

export const TYP_LABEL: Record<string, string> = {
  mieter: 'Mieter', eigentuemer: 'Eigentümer', dienstleister: 'Dienstleister', kontakt: 'Kontakt', contact: 'Kontakt', objekt: 'Objekt', ticket: 'Ticket', rechnung: 'Rechnung',
  vertrag: 'Vertrag', email: 'E-Mail', dokument: 'Dokument', termin: 'Termin', zaehler: 'Zähler', einheit: 'Einheit',
  command: 'Befehl', hit: 'Treffer',
};
